import { useQuery } from "react-query";
import useGlobalContext from "./globalData";

export const useOrganizationTheme = (
  organizationId: string | undefined,
  enabled: boolean
) => {
  const { siteThemeService } = useGlobalContext();

  return useQuery(
    ["organizationSiteTheme", organizationId],
    () => siteThemeService.getSiteThemeByOrganization(organizationId!),
    {
      enabled: enabled && !!organizationId,
      staleTime: Infinity,
    }
  );
};
